import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const ClientBookingPaymentSuccess = () => {
  document.title = "Payment success | Client";

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Bookings" breadcrumbItem="Payment success" />

        <Row className="justify-content-center">
          <Col lg={7} xl={6}>
            <Card>
              <CardBody className="text-center py-5">
                <h4 className="mb-2 text-success">Payment successful</h4>
                <p className="text-muted mb-4">
                  Your payment was completed successfully.
                </p>
                <Button tag={Link} to="/client/bookings" color="primary">
                  Back to All bookings
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ClientBookingPaymentSuccess;
